import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "main-content bg_gray d-flex flex-column transition overflow-hidden" }

import { onMounted } from "vue";

import BreadcrumbMenu from "../../components/Common/BreadcrumbMenu.vue";
import MainFooter from "../../components/Layouts/MainFooter.vue";
import MainHeader from "../../components/Layouts/MainHeader.vue";
import MainSidebar from "../../components/Layouts/MainSidebar.vue";
import CreateUnitModal from "../../components/Settings/UnitList/CreateUnitModal.vue";
import UnitList from "../../components/Settings/UnitList/UnitList.vue";
import { useUnit } from "../../composables/useUnit";


export default /*@__PURE__*/_defineComponent({
  __name: 'UnitListPage',
  setup(__props) {

const {
  searchQuery,
  filteredUnits,
  showModal,
  selectedUnit,
  form,
  errors,
  loading,
  paginationConfig,
  fetchUnits,
  openCreateModal,
  openEditModal,
  closeModal,
  updateField,
  generateUnitCode,
  saveUnit,
  deleteUnit,
} = useUnit();

onMounted(fetchUnits);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(MainHeader),
    _createVNode(MainSidebar),
    _createElementVNode("div", _hoisted_1, [
      _createVNode(BreadcrumbMenu, { pageTitle: "unit_page.list_title" }),
      _createVNode(UnitList, {
        units: _unref(filteredUnits),
        "search-query": _unref(searchQuery),
        "pagination-config": _unref(paginationConfig),
        "onUpdate:searchQuery": _cache[0] || (_cache[0] = ($event: any) => (searchQuery.value = $event)),
        onCreate: _unref(openCreateModal),
        onEdit: _unref(openEditModal),
        onDelete: _unref(deleteUnit)
      }, null, 8, ["units", "search-query", "pagination-config", "onCreate", "onEdit", "onDelete"]),
      _cache[1] || (_cache[1] = _createElementVNode("div", { class: "flex-grow-1" }, null, -1)),
      _createVNode(MainFooter),
      _createVNode(CreateUnitModal, {
        open: _unref(showModal),
        "is-edit": !!_unref(selectedUnit),
        form: _unref(form),
        errors: _unref(errors),
        loading: _unref(loading),
        onClose: _unref(closeModal),
        onSave: _unref(saveUnit),
        onGenerateCode: _unref(generateUnitCode),
        onUpdateField: _unref(updateField)
      }, null, 8, ["open", "is-edit", "form", "errors", "loading", "onClose", "onSave", "onGenerateCode", "onUpdateField"])
    ])
  ], 64))
}
}

})